<template>
    <div>
        <div class="top_nav">
            <div class="w1200">
                <span>
                    <span v-if="isshowit==='true'">
                        你好，
                        <router-link :to="{name:'releaseresources'}" class="color_sub">{{username}}</router-link>
                        ，欢迎来到物流{{comUrl.nodeCity.name}}！
                        <el-button type="text" @click="deletUser">[退出登录]</el-button>
                    </span>
                    <span v-else>
                        <span class="fl">你好，欢迎来到物流{{comUrl.nodeCity.name}}！</span>
                        <router-link :to="{name:'login'}" class="color_main">
                            <i class="iconfont icon-denglu f14"></i>登录
                        </router-link>
                        <span class="color_main f12">|</span>
                        <router-link :to="{name:'register'}" class="color_main">注册</router-link>
                    </span>
                </span>
                <span class="fr">
                    <i class="iconfont icon-dianhua"></i>Tel：199-1234-8061
                </span>
            </div>
        </div>
        <div class="bgwhite">
            <!-- <div class="w1200 htad80 pt20 list_ad ad-list">
                <li style="margin-top:0">
                    <i>广告</i>
                    <img src="static/images/topbanner.png" />
                </li>
            </div>-->
            <!-- <div class="w1200 htad80 pt20 list_ad ad-list"><li style="margin-top:0"><i>广告</i>
            <a href="https://wlzh.ywb56.com/" target="_blank"><img src="/static/images/topbannerzhanhui.png"></a></li></div>-->
            <div class="w1200 ht130">
                <router-link :to="{name:'index'}" class="fl" style="width:210px; height:130px">
                    <el-image :src="logourl" :fit="fit" style="width:210px; height:130px" alt="物流唐山"></el-image>
                </router-link>
                <div class="search_box">
                    <div class="search_input">
                        <input type="text" placeholder="请输入您要搜索的企业名称关键字" v-model="form.title" />
                        <router-link :to="{name:'logisticsdirectories',query:{ title: form.title }}">
                            <i class="iconfont icon-sousuo2 f24"></i>
                            <span>搜索</span>
                        </router-link>
                    </div>
                </div>
                <div class="fr pt15">
                    <div class="gl_logo" @click="jumpTo('ywb56.com')">
                        <img src="/static/images/ywblogo.svg" alt="链物流" width="180" height="40" />
                    </div>
                </div>
            </div>
        </div>
        <div class="menu">
            <div class="w1200">
                <ul :class="(comUrl.nodeCity.resourcePlatform==comUrl.nodeCity.Platform)?'flex-de':'t_xqmenu flex-de'">
                    <li :class="(id==0)?'t_on':''">
                        <router-link :to="{name:'index'}">首页</router-link>
                    </li>
                    <li :class="(id==1)?'t_on':''">
                        <router-link :to="{name:'association'}">{{comUrl.nodeCity.name}}物流协会</router-link>
                    </li>
                    <li :class="(id==9)?'t_on':''">
                        <router-link :to="{name:'committee'}">{{comUrl.nodeCity.name}}行业物流专委会</router-link>
                    </li>
                    <li :class="(id==10)?'t_on':''" v-if="comUrl.nodeCity.resourcePlatform==comUrl.nodeCity.Platform">
                        <router-link :to="{name:'nodelist'}">{{comUrl.nodeCity.name}}区域物流</router-link>
                    </li>
                    <li :class="(id==2)?'t_on':''">
                        <router-link :to="{name:'logisticstrade'}">{{comUrl.nodeCity.name}}物流交易</router-link>
                    </li>
                    <li :class="(id==3)?'t_on':''">
                        <router-link :to="{name:'logisticspark'}">{{comUrl.nodeCity.name}}物流园区</router-link>
                    </li>
                    <li :class="(id==4)?'t_on':''">
                        <router-link :to="{name:'logisticswarehouse'}">{{comUrl.nodeCity.name}}仓储物流</router-link>
                    </li>
                    <li :class="(id==5)?'t_on':''">
                        <router-link :to="{name:'logisticsline'}">{{comUrl.nodeCity.name}}物流专线</router-link>
                    </li>
                    <!--
          <li :class="(id==7)?'t_on':''">
            <router-link :to="{name:'logisticsnews'}">物流资讯</router-link>
                    </li>-->
                    <li :class="(id==8)?'t_on':''">
                        <router-link :to="{name:'logisticsjob'}">{{comUrl.nodeCity.name}}物流招聘</router-link>
                    </li>
                    <li :class="(id==6)?'t_on':''">
                        <router-link :to="{name:'logisticsdirectories',query:{menutitle:'全部分类'}}">{{comUrl.nodeCity.name}}物流名录</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "hometop",
    props: ["id"],
    data() {
        return {
            form: {
                title: "",
            },
            fit: "contain",
            msg: "",
            username: localStorage.getItem("companyName"),
            isshowit: localStorage.getItem("islogin"),
            logourl: "",
        };
    },
    created() {
        console.log(this.isshowit);
        if (
            this.comUrl.nodeCity.resourcePlatform !=
            this.comUrl.nodeCity.Platform
        ) {
            this.getcontrylogo();
        } else {
            this.logourl =
                "/static/images/" +
                this.comUrl.nodeCity.resourcePlatform +
                "/logo.svg";
        }
    },
    methods: {
        jumpTo: function (e) {
            window.open("http://www." + e, "_blank");
        },
        deletUser: function () {
            this.$store.dispatch("delete_user");
            this.$router.push("/login");
            console.log(localStorage);
        },
        getcontrylogo() {
            let data = {
                iType: 1,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                nvcResourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                iCoIdentifier: Number(
                    this.comUrl.nodeCity.resourcePlatform.replace("0315", "")
                ),
            };
            console.log(data, "eee");
            debugger;
            this.$axios
                .post(
                    "/information/AssociationService/getAssociationNodeList",
                    data
                )
                .then((res) => {
                    debugger;
                    console.log(res, "logourl");
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.logourl = infordata[0].nvcNodeLogo;
                    }
                });
        },
    },
};
</script>
<style scoped>
.top_nav {
    height: 40px;
    line-height: 40px;
    background: #f2f2f2;
    border-bottom: 1px solid #e5e4e4;
}
.top_nav a {
    padding-left: 5px;
}
.logo_padding {
    margin: 28px 0;
    display: block;
}
.gl_logo {
    width: 185px;
    height: 62px;
    border: 1px solid #e8e8e8;
    margin-top: 18px;
    cursor: pointer;
}
.gl_logo img {
    display: block;
    margin: 10px auto 0px;
}
.search_box {
    width: 534px;
    float: left;
    padding-left: 160px;
    padding-top: 40px;
}
.search_box li {
    width: 50px;
    margin-right: 15px;
    height: 25px;
    float: left;
    line-height: 25px;
    text-align: center;
    color: #333;
}
.search_box li.on {
    background: #fd5705;
    color: #fff;
}
.search_input input {
    width: 414px;
    height: 42px;
    border: 2px solid #fd5705;
    padding-left: 12px;
    float: left;
}
.search_input a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 104px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    color: #fff;
    float: left;
    background: #fd5705;
    font-size: 18px;
    cursor: pointer;
}
.menu {
    height: 44px;
    line-height: 44px;
    background: #0060c6;
}
.menu li {
    padding: 0 5px;
    float: left;
    position: relative;
    height: 44px;
    overflow: hidden;
}
.menu li a {
    color: #fff;
    font-size: 15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
}
.menu li:hover::after,
.menu li.t_on::after {
    opacity: 1;
    content: "";
    width: 28px;
    height: 3px;
    background: #fff;
    position: absolute;
    left: 50%;
    margin-left: -14px;
    bottom: 0;
}
.menu .t_xqmenu li {
    padding: 0 10px;
}
.pt20 {
    padding-top: 10px;
}
.flex-de {
    display: flex;
    width: 1200px;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Public/homeTop.vue